module.exports = __webpack_public_path__ + "static/img/bg_rules.da8ee22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_rules.png
// module id = JjlB
// module chunks = 1